module.exports = __webpack_public_path__ + "static/img/card_icon_zjxs@2x.7efdc735.png";